import { getToken, removeToken, setToken, getLoginId, setLoginId, removeLoginId, setLoginLastTime,
  removeLoginLastTime, getClientToken, setClientToken, removeClientToken } from '@/utils/auth'
import { getInfo, logout, phoneRegister, phoneResetPassword, phoneSmsCodeRegister, register } from '@/api/user'
import { resetRouter } from '@/router'
import Session from '@/utils/session'
import File from '@/utils/file'

const state = {
  token: getToken(),
  clientToken: getClientToken(),
  customerId: '',
  customerType: '',
  loginId: '',
  name: '',
  avatar: '',
  showOrNotAuth: '0',
  showOrNotOther: '0'
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_CLIENT_TOKEN: (state, clientToken) => {
    state.clientToken = clientToken
  },
  SET_CUSTOMER_ID: (state, customerId) => {
    state.customerId = customerId
  },
  SET_CUSTOMER_TYPE: (state, customerType) => {
    state.customerType = customerType
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_SHOW_OR_NOT_AUTH: (state, showOrNotAuth) => {
    state.showOrNotAuth = showOrNotAuth
  },
  SET_SHOW_OR_NOT_OTHER: (state, showOrNotOther) => {
    state.showOrNotOther = showOrNotOther
  }
}

const actions = {
  // user register
  register({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      register({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user register
  phoneRegister({ commit }, param) {
    return new Promise((resolve, reject) => {
      phoneRegister(param).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  phoneSmsCodeRegister({ commit }, param) {
    return new Promise((resolve, reject) => {
      phoneSmsCodeRegister(param).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  phoneResetPassword({ commit }, param) {
    return new Promise((resolve, reject) => {
      phoneResetPassword(param).then(response => {
        const { data } = response
        this.$store.commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user login
  phoneLogin({ commit }, token) {
    commit('SET_CLIENT_TOKEN', token)
    setClientToken(token)
    setToken(token)
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo({ accessToken: state.token }).then(response => {
        const data = {}
        data.name = response.data.username
        data.avatar = File.url(response.data.avatar)
        data.customerId = response.data.customerId
        data.customerType = response.data.customerType
        Session.setItem('customerId', response.data.customerId)
        Session.setItem('customerType', response.data.customerType)
        Session.setItem('authFlag', response.data.authFlag)
        Session.setItem('phoneMask', response.data.customerPhoneMask)
        Session.setItem('phone', response.data.customerPhone)
        Session.setItem('customerCode', response.data.customerCode)
        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const { customerId, name, avatar, customerType } = data
        commit('SET_CUSTOMER_ID', customerId)
        commit('SET_CUSTOMER_TYPE', customerType)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout({ commit, state, dispatch }) {
    console.log('logout', getLoginId())
    return new Promise((resolve, reject) => {
      logout({ loginId: getLoginId() }).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_CLIENT_TOKEN', '')
        commit('SET_CUSTOMER_ID', '')
        commit('SET_CUSTOMER_TYPE', '')
        commit('SET_SHOW_OR_NOT_AUTH', '0')
        commit('SET_SHOW_OR_NOT_OTHER', '0')
        resetRouter()
        removeToken()
        removeLoginId()
        removeLoginLastTime()
        Session.removeItem('customerId')
        Session.removeItem('customerType')
        Session.removeItem('authFlag')
        Session.removeItem('phoneMask')
        Session.removeItem('phone')
        Session.removeItem('customerCode')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_CUSTOMER_ID', '')
      commit('SET_CUSTOMER_TYPE', '')
      commit('SET_SHOW_OR_NOT_AUTH', '0')
      commit('SET_SHOW_OR_NOT_OTHER', '0')
      removeToken()
      removeClientToken()
      removeLoginId()
      removeLoginLastTime()
      Session.removeItem('customerId')
      Session.removeItem('customerType')
      Session.removeItem('authFlag')
      Session.removeItem('phoneMask')
      Session.removeItem('phone')
      Session.removeItem('customerCode')
      resolve()
    })
  },

  clientLogin({ commit }, param) {
    commit('SET_TOKEN', param.token)
    setToken(param.token)
    setLoginId(param.loginId)
    setLoginLastTime(param.loginLastTime)
    Session.setItem('customerType', param.customerType)
    if (param.name != null) {
      Session.setItem('customerName', param.name)
    } else {
      Session.setItem('customerName', '临时客户')
    }
    Session.setItem('isHavePhone', param.isHavePhone)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
